"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = void 0;
function format(bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (bytes === 0) {
        return '0 Bytes';
    }
    var k = 1000;
    var dm = decimals;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
exports.format = format;
//# sourceMappingURL=byte.js.map